import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Slider from '@mui/material/Slider';
import SliderOneColor from './SliderOneColor/index.js';
import './slider.scss';

import { Input } from "../index.js";

/**
 * Builds a slider component.
 * @property {int} sliderStep - Allows setting the number of units through which the slider increases and decreases.
 * ...
 * ..
 * .
 */
const CustomizedSlider = (props) => {

  const {
    className,
    min,
    max,
    colorOne,
    colorThree,
    colorTwo,
    value,
    isMultiple,
    valueLabelDisplay,
    onChange,
    sliderOneColor,
    colorFour,
    colorFive,
    showValue,
    measure,
    disabled,
    sliderStep,
    blueSlider
  } = props

  const [edit, setEdit] = useState(false);
  const [currentValue, setCurrentValue] = useState(value)
  let valueOne, valueTwo, valueThree, valueFour;
  if (isMultiple) {
    [valueOne, valueTwo, valueThree, valueFour] = value;
  }
  const handleChange = (e, value) => {
    value = Number(value);
    setEdit(false)
    if (isMultiple) {
      const [start, end] = value;
      if (end !== start && end < max && start > min) {
        if (value !== currentValue) {
          onChange(value);
          setCurrentValue(value);
        }
      }
    } else {
      if (value >= min && value <= max) {
        if (value !== currentValue) {
          onChange(value);
          setCurrentValue(value);
        }
      }
    }
  };

  const getColors = () => {
    if (valueOne) {
      const calculatePercentage = (value, total) => {
        return (value / total) * 100;
      }
      // to five colors change colorthree for colorfive and valuetwo for valuefour
      const colors= `linear-gradient(to right, ${colorOne}, ${colorOne} ${calculatePercentage(valueOne,max)}%, ${colorThree} ${calculatePercentage(valueTwo,max)}%, ${colorThree})`;
      return colors;
    }
  }

  const sliderColors = getColors()

  // Dynamic Styles to be Apply depending of the Slider Type
  const customStyles = {
    root: {
      sx: {
        color: '#ccc',
        width: '100%',
        height: '8px'
      }
    },
    thumb: {
      sx: {
        height: isMultiple ? "24px" : "17px",
        width: isMultiple ? "24px" : "17px",
        backgroundColor: '#fff',
        "&>.row-value-label": {
          marginTop: "5px",
          left: isMultiple ? null : 'calc(-50% + 1px)'
        },
        '&:focus, &:hover, &$active': {
          boxShadow: 'inherit',
        },
        background: colorOne,
        "&~&": {
          background: colorTwo
        },
        "&~&~&": {
          background: colorThree
        },
        "&~&~&~&": {
          background: colorFour
        },
        "&~&>.row-value-label": {
          background: colorTwo
        },
        "&~&~&>.row-value-label": {
          background: colorThree
        },
        "&~&~&~&>.row-value-label": {
          background: colorFour
        },
        "&~&>.row-value-label::after": {
          borderTopColor: `${colorTwo} !important`
        },
        "&~&~&>.row-value-label::after": {
          borderTopColor: `${colorThree} !important`
        },
        "&~&~&~&>.row-value-label::after": {
          borderTopColor: `${colorFour} !important`
        },
        circle: {
          borderRadius: '0 0 0 0',
        }
      }
    },
    valueLabel: {
      sx: {
        left: 'calc(-50% + 7px)',
        circle: {
          borderRadius: '0 0 0 0'
        },
        '&::after': {
          borderTopColor: `${colorOne} !important`
        },
        background: colorOne
      }
    },
    track: {
      sx: {
        background: (isMultiple ? colorTwo : colorOne) || "red"
      }
    },
    rail: {
      sx: {
        opacity: 1,
        background: sliderColors,
      }
    }
  }

  return (
    <div style={{ display: 'flex' }}>
      {
        sliderOneColor ?
          (
            <SliderOneColor
              value={value}
              onChange={handleChange}
              min={min}
              max={max}
              start={valueOne}
              end={valueTwo}
              colorone={colorOne}
              colortwo={isMultiple ? colorTwo : colorOne}
              colorthree={colorThree}
              colorfour={colorFour}
              colorfive={colorFive}
              valueLabelDisplay={valueLabelDisplay}
              disabled={props.disabled || false}
              blueSlider={blueSlider}
              step={sliderStep}
            />
          ) : (
            <Slider
              className="myCustomSlider"
              classes={{
                valueLabel: 'row-value-label'
              }}
              value={value}
              arrayvalues={value}
              onChange={handleChange}
              min={min}
              max={max}
              valueLabelDisplay={valueLabelDisplay}
              disabled={disabled || false}
              step={sliderStep}
              blueSlider={blueSlider}
              slotProps={customStyles}
            />
          )
      }
      {showValue && !edit && (
        <div onClick={() => {
          if (!disabled) {
            if (value !== +currentValue)
              setCurrentValue(value)
            setEdit(!edit);
          }
        }} className={`${className ? className : "row-value-display"}`}><strong>{`${value} ${measure ? measure : ""}`}</strong></div>
      )}
      {showValue && edit && (

        <Input
          type="number"
          name="input"
          id="input"
          className={`${className ? className : "row-value-display-short"}`}
          value={currentValue}
          onChange={(value) => {
            if (value !== currentValue)
              setCurrentValue(value)
          }}
          max={max}
          min={min}
          disabled={disabled || false}
          onKeyDown={(event) => {
            event.persist()
            if (event.key === 'Enter') {
              //call to update the new value 
              setEdit(!edit);
              handleChange(null, currentValue);
            } else if (event.key === 'Escape') {
              //call to update the new value 
              setEdit(!edit);
              handleChange(null, currentValue);
            }

          }}
          onBlur={() => {
            setEdit(!edit);
            handleChange(null, currentValue);
          }}
        />

      )}
    </div>
  );
};

CustomizedSlider.defaultProps = {
  min: 0,
  max: 100,
  colorOne: '#03a9f4',
  colorThree: '#ccc',
  value: 30,
  isMultiple: false,
  valueLabelDisplay: "on",
  sliderStep: 1,
}

CustomizedSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: (props, propName, componentName) => {
    let error;
    const max = props[propName];
    const min = props['min'];
    if (!max) {
      error = new Error(`\`${componentName}\` max is required.`,);
    }
    if (max <= min) {
      error = new Error(`\`${componentName}\` max should be greater than min.`,);
    }
    return error;
  },
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number
  ]),
  isMultiple: PropTypes.bool,
  valueLabelDisplay: PropTypes.string,
  colorOne: PropTypes.string,
  colorTwo: PropTypes.string,
  colorThree: PropTypes.string,
  colorFour: PropTypes.string,
  colorFive: PropTypes.string,
  sliderOneColor: PropTypes.bool,
  sliderStep: PropTypes.number,
};

export default CustomizedSlider;